<template>
  <div class="header">
    <!--header start-->
    <el-affix>
      <el-menu
        class="el-menu-top-navigation"
        mode="horizontal"
        :ellipsis="false"
        :router="true"
      >
        <el-menu-item index="#" @click="callChildMethod" class="no-hover-effect">
             <button type="button" :class="['btn btn-hamburger', { collapsed: isMenuHidden }]" data-bs-toggle="collapse" data-bs-target="#adminControl" aria-controls="adminControl" :aria-expanded="String(!isMenuHidden)" aria-label="Dashboard Sidebar">
                <span class="line start"></span>
                <span class="line center"></span>
                <span class="line end"></span>
            </button>
        </el-menu-item>

        <el-menu-item index="/" class="no-hover-effect home-menu">
           <img :src="homeSrc" class="nav-linkHome" alt="home" style="width: 25px;" />
        </el-menu-item>
        <el-menu-item index="share" class="share-icon text-danger"><i class="fas fa-share-alt"></i></el-menu-item>
        <el-menu-item index="facebook" class="circle-icon-item"><i class="fab fa-facebook-f"></i></el-menu-item>
        <el-menu-item index="twitter" class="circle-icon-item"><i class="fab fa-twitter"></i></el-menu-item>
        <el-menu-item index="email" class="circle-icon-item"><i class="fas fa-envelope"></i></el-menu-item>
        <el-menu-item index="comment" class="circle-icon-item"><i class="fas fa-comment"></i></el-menu-item>

        <div class="flex-grow" />

        <el-sub-menu index="22" class="no-active-highlight">
          <template #title>
            <el-badge v-model="notification_count" class="item badge-notification">
              <i class="fas fa-bell"></i>
            </el-badge>
          </template>
          <el-menu-item index="/">Dashboard</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="2" class="no-active-highlight">
          <template #title>
            <img src="@/assets/images/system/user-F.png" />
            &nbsp; Hello, {{ welcome_name }}
          </template>
          <el-menu-item index="/">Dashboard</el-menu-item>
          <el-menu-item index="/setting">Settings</el-menu-item>
          <el-menu-item index="/logout"
            >Sign out &nbsp; <img src="@/assets/images/system/logout.svg" class="append"
          /></el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-affix>
    <!--header end-->

    <!--dashboard container start-->
    <section class="dashboard-container">
      <!--dashboard left side bar start-->
      <AsideMenu ref="side_menu" />
      <!--dashboard left sidebar ended-->
      <div :class="['dashboard-body ', { 'full-width-body': isMenuHidden }]">
        <!-- view -->
        <router-view />
      </div>
      <!--dashboard main body end-->
    </section>
    <!--ended dashboad container-->
  </div>
</template>
<script>
// Please just use `@` to refer to the root "src" directory of the project
import homeSrc from "@/assets/images/system/home.png";
import AsideMenu from "@/components/partials/AsideMenu.vue";

export default {
  name: "UserDashboard",
  components: {
    AsideMenu,
  },
  data() {
    return {
      loadingInstance: null,
      notification_count: "",
      isMenuHidden: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    welcome_name() {
      return this.user ? this.user.welcomename : "Loading...";
    }
  },
  mounted() {
  },
  setup() {
    return {
      homeSrc,
    };
  },
  methods: {
    callChildMethod() {
      // Access the child component instance using $refs
      this.isMenuHidden = !this.isMenuHidden;
      if (this.$refs.side_menu) {
        this.$refs.side_menu.collapseToggle();
      }
    },
  },
};
</script>

<style>
/* Fix the top nav bar so it never scrolls away */
.el-menu-top-navigation {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100% !important;
  z-index: 1030;
}

/* Push the dashboard section below the fixed top nav */
.dashboard-container {
  padding-top: 60px;
}

.dashboard-body {
  margin-left: 200px; /* match the fixed sidebar width */
  transition: margin-left 0.3s ease-in-out, width 0.3s ease-in-out;
}

.full-width-body {
  margin-left: 0;
  width: 100%;
}

/* Prevent notification & hello sub-menus from showing active highlight */
.no-active-highlight.el-sub-menu.is-active > .el-sub-menu__title {
  border-bottom-color: transparent !important;
}
.no-active-highlight.el-sub-menu.is-active > .el-sub-menu__title i,
.no-active-highlight.el-sub-menu.is-active > .el-sub-menu__title {
  color: inherit !important;
}
</style>
